import { useState, useEffect } from "react";
import { BaseButton } from "../../components/base";
import { useNotification } from "../../context/NotificationProvider";
import { verify, resendOtp } from "../../api/auth/authAPI";
import { Box, Typography, TextField } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import useAuth from '../../hooks/useAuth';
import URIs from "../../utils/uri";
import logo from "../../assets/images/hashinLogoLight.png";
import { jwtDecode } from "jwt-decode";

const Verify = () => {
    const [otp, setOtp] = useState(["", "", "", "", ""]);
    const [isLoading, setIsloading] = useState(false);
    const [counter, setCounter] = useState(60);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const {showNotification} = useNotification();
    const { setAuth } = useAuth();
    const location = useLocation();
    const phone = location.state?.phoneValue
    const navigate = useNavigate();

    // Handles OTP input change
    const handleOtpChange = (e, index) => {
        const value = e.target.value;
        if (/[^0-9]/.test(value)) return; // Only allow numeric values

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Auto-focus next input field if it's filled
        if (value && index < otp.length - 1) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }
        
    };
    useEffect(() => {
        if (otp.every((field) => field !== "")) {
            handleOtpSubmit();
        }
    }, [otp]);
    // Verifies OTP and auto logs in if successful
    const handleOtpSubmit = async () => {
        const otpCode = otp.join("");
        setIsloading(true);
        try {
            const res = await verify(phone, otpCode);
            setAuth(prev => {
                let decodedToken = jwtDecode(res.accessToken)
                const roles = decodedToken.roles
                return { ...prev, roles: roles, firstName: res.firstName, authStatus : res.authStatus, accessToken: res.accessToken }
            });
            if(res.authStatus === 1){
                navigate(URIs.SET_PASSWORD, { state: { phone } });
            }else if(res.authStatus === 2){
                navigate(URIs.KYC);
            }else if(res.authStatus === 3){
                navigate(URIs.HOME);
            }else{
                navigate(URIs.HOME);
            }
        } catch (error) {
            showNotification(error, 'error');
        } finally {
            setIsloading(false);
        }
    };

    const handleResendCode = async () => {
        setCounter(60);
        setIsResendDisabled(true);
        try {
            await resendOtp(phone);
        } catch (error) {
            showNotification(error, 'error');
        }
    };

    // Countdown logic for the resend button
    useEffect(() => {
        let timer;
        if (isResendDisabled && counter > 0) {
          timer = setInterval(() => {
            setCounter((prev) => prev - 1);
          }, 1000);
        }
        if (counter === 0) {
          setIsResendDisabled(false);
          setCounter(60); // Reset the counter for next resend
        }
    
        return () => clearInterval(timer);
    }, [counter, isResendDisabled]);

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="flexStart"
            alignItems="center"
            padding={2}
            gap={4}
            sx={{ height: "100vh", paddingTop: "80px" }}
        >
            <img src={logo} alt="Logo" style={{ width: "120px" }} />
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2} sx={{width: "90%", maxWidth: 400}}>
                <Typography variant="subtitle" sx={{ textAlign: 'center' }}>
                    کد تایید پیامک شده به شماره {`${phone}`} را وارد کنید.
                </Typography>
            </Box>
            <Box display="flex" gap={2} justifyContent="center" alignItems="center" marginTop={2} flexDirection="row-reverse">
                {otp.map((value, index) => (
                    <TextField
                        key={index}
                        id={`otp-input-${index}`}
                        value={value}
                        onChange={(e) => handleOtpChange(e, index)}
                        sx={{ width: 40, height: 40, textAlign: 'center' }}
                        variant="outlined"
                        size="small"
                    />
                ))}
            </Box>
            <BaseButton
                type="button"
                onClick={handleOtpSubmit}
                isLoading={isLoading}
                sx={{ marginTop: 2, width: "90%", maxWidth: 400 }}
            >
                تایید کد
            </BaseButton>
            <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" gap={2}>
            <Typography variant="subtitle">کد پیامک نشد؟</Typography>
            <Typography
                variant="subtitle"
                color="textDark"
                onClick={handleResendCode}
                sx={{
                    cursor: isResendDisabled ? 'not-allowed' : 'pointer',
                    opacity: isResendDisabled ? 0.5 : 1
                }}
            >
                {isResendDisabled ? `ارسال مجدد (${counter})` : 'ارسال مجدد کد'}
            </Typography>
            </Box>
        </Box>
    );
};

export default Verify;
